export default __webpack_public_path__ + "static/media/main-page-new.763f707b.jpg";